import {useServices} from "../../../react-hooks/use-services.hook";
import React, {useState} from "react";
import {IStandardToastDefinition} from "../../../services/toaster/toaster.service.interface";
import {TimeSpan} from "@sparkware/app-utils";
import {Button} from "../../../basic-ui-components/button/base/button.component";
import {TextareaBox} from "../../../basic-ui-components/form/textarea.box";
import {Label} from "../boxes/label";
import {ShowcaseConfigurationBox} from "../boxes/showcase-configuration/showcase-configuration.box";
import {ShowcaseContentContainerBox} from "../boxes/showcase-content-container/showcase-content-container.box";
import {shuffle} from "../../../../utils/array-helper";
import {DailyJackpotThresholdToastPresenter} from "../../../services/jackpots/models/toast-presenters/daily-jackpot-threshold-toast-presenter";
import {KnownJackpotId} from "../../../services/jackpots/jackpot.constants";
import {Select} from "../../../basic-ui-components/form/select.component";
import {DailyJackpotDropToastPresenter} from "../../../services/jackpots/models/toast-presenters/daily-jackpot-drop-toast-presenter";

const BASE_CONTENT = {
    title: 'Test toaster',
    message: 'This is an example for standard toaster',
    showProgressBar: true,
    showDefaultImage: true,
    showDefaultButton: false,
};
const BASE_BUTTON = {
    text: 'Close toaster',
    onClick: (closeToast) => {closeToast()}
};

export const ToasterShowcase: React.FC = () => {
    const [toasterOpt, setToasterOpt] = useState(BASE_CONTENT);
    const services = useServices();
    const jackpotTypes = [KnownJackpotId.Daily, KnownJackpotId.Twilight, KnownJackpotId.HourlyCaptain8];
    const [jackpotTypeToast, setJackpotTypeToast] = useState(KnownJackpotId.Daily);

    const onChangeInput = (ev) => {
        const value = ev.target.type === 'checkbox' ? ev.target.checked : ev.target.value;
        const field = ev.target.name;
        setToasterOpt({...toasterOpt, [field]: value});
    };

    const showToast = () => {
        const customizeToasterOptions: IStandardToastDefinition = {
            contentProps: {
                title: toasterOpt.title,
                message: toasterOpt.message,
                image: toasterOpt.showDefaultImage && 'DEFAULT_TOAST_IMAGE',
                button: toasterOpt.showDefaultButton && BASE_BUTTON
            },
            toastOptions: {
                timeout: toasterOpt.showProgressBar && TimeSpan.fromMilliseconds(5000)
            }
        };

        services.toaster.showStandardToast(customizeToasterOptions);
    };

    const showJackpotThresholdToast = () => {
        let a = new DailyJackpotThresholdToastPresenter(services);
        let toastsConfiguration = services.configuration.data.jackpotToaster?.forJackpots[jackpotTypeToast];
        let mockedThresholdBatch = {
            "gameTypes": [130191],
            "showGameIcon": false,
            "thresholds": [
                {
                    threshold: 4000000,
                    toasterName: 'DAILY_JP_ALERT_40K',
                    contentText: 'jackpot_amount_threshold_text_template2'
                },
                {
                    threshold: 2500000,
                    toasterName: 'DAILY_JP_ALERT_25K',
                    contentText: 'jackpot_amount_threshold_text_template1'
                }
            ]
        };
        a.showToast({
            thresholdBatchConfiguration: mockedThresholdBatch, // toastsConfiguration.thresholdsBatch,
            defaultToastTitle: toastsConfiguration.defaultThresholdTitle,
            previousAmount: 2499920, // options.previousAmountInCents,
            currentAmount: 2500075, // options.currentAmountInCents,
            gameTypes: shuffle([130043, 130191, 130017, 130020, 130002, 2380126, 130110]), // options.gameTypes,
            jackpotId: jackpotTypeToast, // options.jackpotId,
            mustHitTime: new Date(Date.now() + 38945612) // options.mustHitTime
        });

    }

    const showJackpotDropToast = () => {
        let a = new DailyJackpotDropToastPresenter(services);
        let toastsConfiguration = services.configuration.data.jackpotToaster?.forJackpots[jackpotTypeToast];

        a.showToast({
            toastId: `JP_DROP_ALERT_${jackpotTypeToast}`,
            titleText: toastsConfiguration.dropTitleEnhanced,
            secondTitleText: toastsConfiguration.dropSecondTitle,
            winAmountInCents: 4125869,
            imageUrl: services.theme.currentTheme.assets.images.jackpot_widget.crown_png.toString(),
            gameTypes: shuffle([130043, 130191, 130017, 130020, 130002, 2380126, 130110]),
            jackpotId: jackpotTypeToast
        });
    }

    const closeToasters = () => {
        services.toaster.removeAllToasts()
    };

    return (<>
            <ShowcaseContentContainerBox>
                <ShowcaseConfigurationBox>
                    <h3>Title:</h3>
                    <input type="text" value={toasterOpt.title} name="title" onChange={onChangeInput} />
                </ShowcaseConfigurationBox>

                <ShowcaseConfigurationBox>
                    <h3>Message:</h3>
                    <TextareaBox
                        style={{fontSize: "1.6rem", width: "100%", resize: "vertical"}}
                        rows={4}
                        name='message'
                        value={toasterOpt.message}
                        onChange={onChangeInput}
                    />
                </ShowcaseConfigurationBox>

                <ShowcaseConfigurationBox>
                    <h3>Options:</h3>
                    <div>
                        <input
                            type="checkbox"
                            name="showProgressBar"
                            id="showProgressBar"
                            checked={toasterOpt.showProgressBar}
                            onChange={onChangeInput}
                        />
                        <Label htmlFor='showProgressBar'>Show Progress bar (5s)</Label>
                    </div>

                    <div>
                        <input
                            type="checkbox"
                            name="showDefaultImage"
                            id="showDefaultImage"
                            checked={toasterOpt.showDefaultImage}
                            onChange={onChangeInput}
                        />
                        <Label htmlFor='showDefaultImage'>Show default image</Label>
                    </div>

                    <div>
                        <input
                            type="checkbox"
                            name="showDefaultButton"
                            id="showDefaultButton"
                            checked={toasterOpt.showDefaultButton}
                            onChange={onChangeInput}
                        />
                        <Label htmlFor='showDefaultButton'>Show default button</Label>
                    </div>
                </ShowcaseConfigurationBox>
            </ShowcaseContentContainerBox>

            <ShowcaseContentContainerBox>
                <Button preset="primary" onClick={showToast}>Toast</Button>
                <Button preset="info" onClick={closeToasters}>Close toasts</Button>
            </ShowcaseContentContainerBox>

            <ShowcaseContentContainerBox>
                <ShowcaseConfigurationBox>
                    <Label>Prize result : </Label>
                    <Select
                        name={"wheel_prize"}
                        id={"wheel_prize"}
                        value={jackpotTypeToast}
                        onChange={(e) => {
                            const rawValue = e.target.options[e.target.selectedIndex].value;
                            const theValue = parseInt(rawValue);
                            setJackpotTypeToast(theValue);
                        }}
                        width="150px"
                    >
                        {jackpotTypes.map((p, idx) =>
                            <option key={p} value={p}>{p}</option>
                        )}
                    </Select>
                </ShowcaseConfigurationBox>
            </ShowcaseContentContainerBox>
            
            <ShowcaseContentContainerBox>
                <Button preset="secondary" onClick={showJackpotThresholdToast}>Jackpot Threshold toast</Button>
                <Button preset="secondary" onClick={showJackpotDropToast}>Jackpot Drop toast</Button>
            </ShowcaseContentContainerBox>

        </>
    );
}